import { useQuestionIsInWorksheet, worksheetActions } from '@src/stores/worksheet.store';
import React from 'react';
import * as styles from './maker.module.css';

const WorksheetCheckbox = ({ hit }) => {
  const checked = useQuestionIsInWorksheet(hit.slug);

  const handleChange = (e) => {
    if (e.target.checked) {
      worksheetActions.addQuestion(hit);
    } else {
      worksheetActions.removeQuestion(hit.slug);
    }
  };

  const checkboxId = `worksheet-${hit.slug}`;

  return (
    <div className={styles.checkbox}>
      <label htmlFor={checkboxId}>
        <input id={checkboxId} type="checkbox" checked={checked} onChange={handleChange} />
        {checked ? 'Remove from' : 'Add to'} worksheet
      </label>
    </div>
  );
};

export default WorksheetCheckbox;
